import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/validation';

const LeadProfileFormSchema = z.object({
  id: z.string().optional(),
  first_name: z
    .string()
    .min(1, { message: VALIDATION_MESSAGES.NAME_REQUIRED })
    .nullish()
    .optional(),
  last_name: z.string().nullish().optional(),
  email: z.string().email({ message: VALIDATION_MESSAGES.EMAIL_INVALID }),
  birth_date: z.string().nullish().optional(),
  city: z.string().nullish().optional(),
  state: z.string().nullish().optional(),
  zip_code: z.string().nullish().optional(),
  address: z.string().nullish().optional(),
  phone: z.string().nullish().optional(),
  meeting_link: z.string().nullish().optional(),
  linkedin: z.string().nullish().optional(),
  preferred_markets: z.array(z.string()).nullish().optional(),
});

export default LeadProfileFormSchema;
